// extracted by mini-css-extract-plugin
module.exports = {"bar":"styles_bar__dHt6r","textArea":"styles_textArea__LDfSi","tag":"styles_tag__MvT1H"};